import { createStore } from 'redux';
import Reducers from './rootReducer';

export const store = createStore(Reducers);
